import React from 'react';
import { RiMailLine } from 'react-icons/ri';
import { handleChange, getError } from '../../helperFunctions';
import ErrorEmptyStateView from '../../../components/ErrorEmptyStateView';
import {
  BankAccountCard,
  LocationCard,
} from '../../../components/UiComponents/InfoCards';
import { Field, TextInput } from '../../../components/UiComponents/Ui';
import { BusinessIdFields, PhoneField } from './SupplierFields';
import Redirects from './Redirects';

const SectionTitle = ({ children }) => (
  <h2 className="text-base font-medium text-gray-600">{children}</h2>
);

const Review = ({
  supplierData,
  setSupplierData,
  formErrors,
  setFormErrors,
  setLocationModalData,
  handleLocationModalOpen,
  setBankAccountModalData,
  handleBankModalOpen,
  handleRemoveBankAccount,
}) => {
  const onChange = (path, value) =>
    handleChange(path, value, setSupplierData, setFormErrors, formErrors);

  const handleRemoveLocation = (index) => {
    setSupplierData((prev) => ({
      ...prev,
      locations: prev.locations?.filter((_, i) => i !== index),
    }));
  };

  return (
    <div className=" flex flex-col items-center justify-center">
      <div className="w-[80%] space-y-6">
        <Field label="Supplier Name" required>
          <TextInput readOnly value={supplierData?.supplierName || ''} />
        </Field>

        <Field label="Supplier Email" required>
          <TextInput
            readOnly
            startIcon={<RiMailLine size={16} className="text-gray-500" />}
            value={supplierData?.email || ''}
          />
        </Field>

        <PhoneField
          supplierData={supplierData}
          onChange={onChange}
          formErrors={formErrors}
        />

        {Array.isArray(supplierData?.companyCodes) &&
          supplierData.companyCodes.length > 0 && (
            <BusinessIdFields
              supplierData={supplierData}
              onChange={onChange}
              formErrors={formErrors}
            />
          )}

        {/* locations */}
        <div className="space-y-2">
          <SectionTitle>Locations</SectionTitle>
          <div className="space-y-6">
            {supplierData?.locations?.length ? (
              supplierData.locations.map((item, index, arr) => (
                <LocationCard
                  key={index}
                  item={item}
                  alwaysShowActions
                  onEdit={() => {
                    setLocationModalData(item);
                    handleLocationModalOpen(true, index);
                  }}
                  onRemove={
                    arr.length > 1
                      ? () => handleRemoveLocation(index)
                      : undefined
                  }
                />
              ))
            ) : (
              <div className="w-[90%]">
                <ErrorEmptyStateView
                  title="No Location Found"
                  description="Please add a location to continue"
                  type="empty"
                />
              </div>
            )}
          </div>
        </div>

        {/* bank accounts */}
        <div className="space-y-2">
          <SectionTitle>Bank Accounts</SectionTitle>
          <div className="space-y-6">
            {supplierData?.bankAccounts?.length ? (
              supplierData.bankAccounts.map((item, index, arr) => (
                <BankAccountCard
                  key={index}
                  item={item}
                  alwaysShowActions
                  onEdit={() => {
                    setBankAccountModalData(item);
                    handleBankModalOpen(true, index);
                  }}
                  onRemove={
                    arr.length > 1
                      ? () => handleRemoveBankAccount(index)
                      : undefined
                  }
                />
              ))
            ) : (
              <div className="w-[90%]">
                <ErrorEmptyStateView
                  title="No Bank Account Found"
                  description="Please add a Bank Account to continue"
                  type="empty"
                />
              </div>
            )}
          </div>
        </div>

        {/* redirects & callbacks (read-only) */}
        <Redirects
          readOnly
          supplierData={supplierData}
          setSupplierData={setSupplierData}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
        />
      </div>
    </div>
  );
};

export default Review;
